import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeEmployeeCreate,
  detail: routeEmployeeDetail,
  home: routeEmployeesHome,
  root: routeEmployeesRoot,
} = createDoctypeRoutes({
  createName: 'new-employee',
  createPath: 'new-employee',
  detailName: 'employeeDetail',
  doctype: DOCTYPES.EMPLOYEE,
  homeName: 'employees-home',
  ifOwner: false,
  path: 'employees',
  views: {
    create: async () => await import('@/components/viewsExternal/employees/AddEmployee.vue'),
    detail: async () => await import('@/components/viewsExternal/employees/ViewEmployee.vue'),
    list: async () => await import('@/components/viewsExternal/employees/EmployeeView.vue'),
  },
})

export { routeEmployeeCreate, routeEmployeeDetail, routeEmployeesHome, routeEmployeesRoot }
